import { createFileRoute, Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { AlOrderScreen } from "./-components/documents/al-order-screen";

export const Route = createFileRoute(
  "/_authenticated/_care/residents/$residentId/al-orders/$orderId",
)({
  component: AlOrderView,
});

function AlOrderView() {
  const { residentId, orderId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );

  return (
    <AlOrderScreen
      orderId={orderId}
      resident={resident}
      back={
        <Link params={{ residentId }} to="/residents/$residentId/physician-poc">
          Back to the chart
        </Link>
      }
      printLabel="Print"
      missingDescription="It may have been removed, or it belongs to another resident. The chart lists every order on file."
    />
  );
}
